export const handleDate = date => {
  return date ? new Date(date).toLocaleDateString('en-US') : '-';
};
